(function ($){
    $(document).ready(function(){
        featuresIconsTabbed();
    });

    function featuresIconsTabbed(){
        var filter_container = $('.filters_wrap');
        if(!is_mobile){
            var filter_tab_container = filter_container.find('.filter-tab'),
                filter_tab = filter_container.find('.single-tab');
            if(filter_tab_container.length > 0){
                filter_tab.each(function(){
                    $(this).on('click', function(){
                       var current_data = $(this).data('filter');
                       $(this).addClass('active').attr('aria-selected',true).removeAttr('tabindex');
                       $(this).siblings().removeClass('active').attr('aria-selected',false).attr('tabindex', -1);
                       featuresIconsTab(current_data);
                    });
                });
                filter_tab.on('keydown', function(e){
                    var btn = $(this),
                        keyCode = e.keyCode || e.which;
                    if(keyCode === 37 || keyCode === 39){
                        if(keyCode === 39){
                            btn.next().focus();
                        } else if(keyCode === 37){
                            btn.prev().focus();
                        }
                    }
                });
            }
        }
        if(is_mobile){
            var filter_select_container = filter_container.find('.filters_select'),
                filter_select = filter_select_container.find('select');
            if(filter_select.length > 0){
                filter_select.on('change', function(){
                    var current_value = $(this).val();
                    featuresIconsTab(current_value);
                });
            }
        }
    }

    function featuresIconsTab(current_tab_data){
        var features_icons_tab = $('.features_icons_tab');
        if(features_icons_tab.length > 0){
            features_icons_tab.each(function(){
                var features_icons_tab_data = $(this).data('filter');
                if(features_icons_tab_data === current_tab_data){
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                }
            });
        }

    }

})(jQuery);